import React, { useState } from "react";
import * as S from "./styles.ts";
import Tabs, { TTab } from "@template/components/Tabs";
import { SearchTab } from "./SearchTab";
import Globe from "@template/icons/Globe.tsx";
import Phone from "@template/icons/Phone.tsx";

interface ICallRatesTabsProps {
  onSearch: (number: string) => void;
  onSearchByCountry: (countryCode: string) => void;
  loading: boolean;
}

export const CallRatesTabs = ({
  onSearch,
  onSearchByCountry,
  loading,
}: ICallRatesTabsProps) => {
  const tabs: TTab[] = [
    {
      label: {
        value: "Call Cost (By Number)",
        startContent: <Phone />,
      },
      content: (
        <SearchTab
          context="number"
          onSearch={onSearch}
          loading={loading}
        />
      ),
    },
    {
      key: "country",
      label: {
        value: "Call Cost (By Country)",
        startContent: <Globe />,
      },
      content: (
        <SearchTab
          context="country"
          onSearchByCountry={onSearchByCountry}
          loading={loading}
        />
      ),
    },
  ];

  const [tab, setTab] = useState(tabs[0].key);

  return (
    <S.CallRatesTabsContainer>
      <Tabs
        tabs={tabs}
        defaultSelected={tab}
        onTabChange={(t) => setTab(t)}
      />
    </S.CallRatesTabsContainer>
  );
};
